<template>
  <div class="about">
    <h1>Status</h1>
    <PilotStatusForm></PilotStatusForm>
  </div>
</template>

<script>
import PilotStatusForm from '@/components/airbox/PilotStatusForm.vue'

export default {
  name: 'Pilotstatus',
  components: {
    PilotStatusForm,
  },
  data: () => ({
    tab: null
  }),
}
</script>